import { ACTIONS, EVENTS } from 'react-joyride';
import { CustomStep } from './Tutorial';

export const createProjectSteps = (): CustomStep[] => {
  const steps: CustomStep[] = [
    {
      content:
        'You can manage your own project templates to enforce best practices across your organization and save your team the headache of having to manually configure every project plan.',
      target: '#template-field',
      disableBeacon: true,
      disableScrolling: true,
      disableScrollParentFix: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.TARGET_NOT_FOUND]: 'openCreateProjectDialog',
      },
      [ACTIONS.PREV]: {
        [EVENTS.STEP_AFTER]: 'closeCreateProjectDialog',
      },
    },
    {
      content:
        'Add additional fields to a project that don’t exist in the standard project form.',
      target: '#add-additional-field',
      disableBeacon: true,
      disableScrolling: true,
      disableScrollParentFix: true,
      placement: 'auto',
      [ACTIONS.NEXT]: {
        [EVENTS.STEP_AFTER]: 'closeCreateProjectDialog',
      },
      [ACTIONS.PREV]: {
        [EVENTS.TARGET_NOT_FOUND]: ['openCreateProjectDialog', 500],
      },
    },
  ];
  return steps;
};
